import { render, staticRenderFns } from "./change-current-businessunit.vue?vue&type=template&id=319efbd5&scoped=true&lang=pug&"
import script from "./change-current-businessunit.vue?vue&type=script&lang=ts&"
export * from "./change-current-businessunit.vue?vue&type=script&lang=ts&"
import style0 from "./change-current-businessunit.vue?vue&type=style&index=0&id=319efbd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319efbd5",
  null
  
)

export default component.exports